import React, { Component } from 'react';

import { getUser } from '../actions/session';
import Axios from 'axios';
import { Notifications } from '../components/common/notification';
import { Redirect, withRouter } from 'react-router-dom';
import { USER_CREATE_PAYMENT_URL } from '../config/rest_endpoints';

/**
 * PaymentAdd - Premium PayPal Payment Form
 *
 * Modal form for adding funds via PayPal with
 * beautiful styling and smooth interactions.
 */
class PaymentAdd extends Component {
  constructor(props) {
    super(props);
    var user = getUser();
    this.state = {
      User: getUser(),
      payment: '',
      userId: user.id,
      urlLink: '',
      msg: '',
      isTrue: false,
      isLoading: false
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.submitPayment = this.submitPayment.bind(this);
  }

  handleInputChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  submitPayment() {
    const { User, payment } = this.state;

    if (!payment || parseFloat(payment) <= 0) {
      Notifications.notify('Please enter a valid amount', 'Error', 'error');
      return;
    }

    var userId = User.id;
    var payload = {
      amount: parseFloat(payment),
      type: 2
    };
    console.log('payload :>> ', payload);
    this.setState({ isLoading: true });
    var headers = { Authorization: 'Bearer ' + User.token };
    Axios.post(`${USER_CREATE_PAYMENT_URL}/${userId}/payment/paypal/create`, payload, { headers })
      .then((res) => {
        if (res) {
          console.log('res payment :>> ', res);
          this.setState({
            urlLink: res.data.data,
            msg: res.data.message,
            isTrue: true,
            isLoading: false
          });
          var url = window.location;
          console.log('url', url);
        } else {
          this.setState({ isLoading: false });
          Notifications.notify('Failed in payment', 'Failed', 'error');
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false });
        var errRes = err.response.data;
        Notifications.notify(errRes.message, 'Error', 'error');
      });
  }

  render() {
    const { payment, urlLink, isTrue, isLoading } = this.state;

    if (isTrue) {
      window.location.href = urlLink;
    }

    // Quick amount buttons
    const quickAmounts = [25, 50, 100, 250];

    return (
      <div style={{ padding: '0.5rem', animation: 'fadeIn 0.3s ease' }}>

        {/* PayPal Header */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '1.5rem',
            padding: '1rem',
            background: 'linear-gradient(135deg, rgba(0, 112, 186, 0.1) 0%, rgba(0, 48, 135, 0.1) 100%)',
            borderRadius: '12px'
          }}
        >
          <i
            className="fab fa-paypal"
            style={{
              fontSize: '2rem',
              background: 'linear-gradient(135deg, #0070BA 0%, #003087 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              marginRight: '0.75rem'
            }}
          ></i>
          <span style={{ fontWeight: 700, fontSize: '1.125rem', color: 'var(--color-text)' }}>
            PayPal Payment
          </span>
        </div>

        {/* Quick Amount Buttons */}
        <div style={{ marginBottom: '1.25rem' }}>
          <label
            style={{
              display: 'block',
              fontSize: '0.75rem',
              fontWeight: 600,
              color: 'var(--color-text-secondary)',
              marginBottom: '0.5rem',
              textTransform: 'uppercase',
              letterSpacing: '0.05em'
            }}
          >
            Quick Select
          </label>
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            {quickAmounts.map((amount) => (
              <button
                key={amount}
                type="button"
                onClick={() => this.setState({ payment: amount.toString() })}
                style={{
                  flex: 1,
                  padding: '0.625rem 0',
                  borderRadius: '8px',
                  border: payment === amount.toString() ? '2px solid #0070BA' : '1px solid var(--color-border)',
                  background: payment === amount.toString() ? 'rgba(0, 112, 186, 0.1)' : 'var(--color-surface)',
                  color: payment === amount.toString() ? '#0070BA' : 'var(--color-text)',
                  fontWeight: 600,
                  fontSize: '0.875rem',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease'
                }}
              >
                ${amount}
              </button>
            ))}
          </div>
        </div>

        {/* Custom Amount Input */}
        <div style={{ marginBottom: '1.5rem' }}>
          <label
            style={{
              display: 'block',
              fontSize: '0.75rem',
              fontWeight: 600,
              color: 'var(--color-text-secondary)',
              marginBottom: '0.5rem',
              textTransform: 'uppercase',
              letterSpacing: '0.05em'
            }}
          >
            <i className="icon-coin-dollar" style={{ marginRight: '0.375rem' }}></i>
            Amount to Add
          </label>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              borderRadius: '10px',
              border: '1px solid var(--color-border)',
              overflow: 'hidden',
              background: 'var(--color-surface)'
            }}
          >
            <span
              style={{
                padding: '0.75rem 1rem',
                background: 'var(--color-bg-subtle)',
                color: 'var(--color-text-secondary)',
                fontWeight: 600,
                fontSize: '1rem',
                borderRight: '1px solid var(--color-border)'
              }}
            >
              $
            </span>
            <input
              type="number"
              name="payment"
              value={payment}
              onChange={this.handleInputChange}
              placeholder="0.00"
              style={{
                flex: 1,
                padding: '0.75rem 1rem',
                border: 'none',
                outline: 'none',
                fontSize: '1.125rem',
                fontWeight: 600,
                color: 'var(--color-text)',
                background: 'transparent'
              }}
            />
            <span
              style={{
                padding: '0.75rem 1rem',
                background: 'var(--color-bg-subtle)',
                color: 'var(--color-text-tertiary)',
                fontSize: '0.875rem',
                borderLeft: '1px solid var(--color-border)'
              }}
            >
              USD
            </span>
          </div>
        </div>

        {/* Submit Button */}
        <button
          type="button"
          onClick={this.submitPayment}
          disabled={isLoading || !payment || parseFloat(payment) <= 0}
          style={{
            width: '100%',
            background:
              isLoading || !payment || parseFloat(payment) <= 0
                ? 'var(--color-bg-subtle)'
                : 'linear-gradient(135deg, #0070BA 0%, #003087 100%)',
            border: 'none',
            borderRadius: '10px',
            padding: '0.875rem 1.5rem',
            color: isLoading || !payment || parseFloat(payment) <= 0 ? 'var(--color-text-tertiary)' : 'white',
            fontWeight: 600,
            fontSize: '1rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.5rem',
            cursor: isLoading || !payment || parseFloat(payment) <= 0 ? 'not-allowed' : 'pointer',
            boxShadow: isLoading || !payment || parseFloat(payment) <= 0 ? 'none' : '0 4px 14px rgba(0, 112, 186, 0.3)'
          }}
        >
          {isLoading ? (
            <>
              <i className="icon-spinner2 spinner"></i>
              Processing...
            </>
          ) : (
            <>
              <i className="fab fa-paypal"></i>
              Pay with PayPal
              {payment && parseFloat(payment) > 0 && (
                <span style={{ opacity: 0.8 }}>(${parseFloat(payment).toFixed(2)})</span>
              )}
            </>
          )}
        </button>

        {/* Security Notice */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.5rem',
            marginTop: '1rem',
            color: 'var(--color-text-tertiary)',
            fontSize: '0.75rem'
          }}
        >
          <i className="icon-lock2"></i>
          <span>Secure payment via PayPal</span>
        </div>
      </div>
    );
  }
}

export default withRouter(PaymentAdd);
